/**
 * Header family behaviors: mobile-menu toggle and the topbar live clock.
 *
 * Single implementation, consolidating what was previously two competing
 * toggleMobileMenu() function declarations (header.blade.php and
 * header-mobile-menu.blade.php both declared a global function of the same
 * name — the second one loaded in the DOM silently won) plus an inline
 * updateTime()/#current-time clock in header.blade.php that targeted an id
 * that does not exist anywhere in the markup and never ran.
 *
 * The desktop nav dropdown open/close behavior needs no JS at all — it is
 * handled by the ".nav-dropdown:hover .dropdown-menu" rule in header.css.
 */

function initializeMobileMenu() {
    const toggleButton = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.getElementById('mobile-menu');
    if (!toggleButton || !menu) return;

    toggleButton.addEventListener('click', function() {
        const isVisible = menu.style.display !== 'none';
        menu.style.display = isVisible ? 'none' : 'block';
    });

    // Close when clicking outside the menu and its toggle button
    document.addEventListener('click', function(e) {
        if (!menu.contains(e.target) && !toggleButton.contains(e.target)) {
            menu.style.display = 'none';
        }
    });

    // Close if the viewport is resized back to desktop width
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768) {
            menu.style.display = 'none';
        }
    });
}

function initializeTopbarClock() {
    // The topbar's date-greeter widget renders a ".current-time" span and
    // updates it here, once a minute.
    const timeDisplay = document.querySelector('.current-time');
    if (!timeDisplay) return;

    setInterval(function() {
        const now = new Date();
        const format = timeDisplay.dataset.format;

        const timeString = format === '12h'
            ? now.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
            : now.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });

        timeDisplay.textContent = timeString;
    }, 60000);
}

export function initializeHeader() {
    initializeMobileMenu();
    initializeTopbarClock();
}
